package com.crowpay.views.screens.contractor

import com.crowpay.views.components.nav.AppDimensions
import com.crowpay.notNullContractor
import com.crowpay.sdk.notNullSession
import com.crowpay.views.components.nav.viewIsNarrow
import com.crowpay.views.components.space
import com.crowpay.views.theming.AppColors
import com.crowpay.views.theming.body
import com.crowpay.views.theming.notificationBar
import com.lightningkite.kiteui.Routable
import com.lightningkite.kiteui.models.dp
import com.lightningkite.kiteui.models.times
import com.lightningkite.kiteui.reactive.Constant
import com.lightningkite.kiteui.reactive.Readable
import com.lightningkite.kiteui.reactive.shared
import com.lightningkite.kiteui.views.ViewWriter
import com.lightningkite.kiteui.views.direct.col
import com.lightningkite.kiteui.views.direct.padded
import com.lightningkite.kiteui.views.direct.rowCollapsingToColumn
import com.lightningkite.kiteui.views.direct.scrolls
import com.lightningkite.kiteui.views.direct.sizeConstraints
import com.lightningkite.kiteui.views.direct.stack
import com.lightningkite.kiteui.views.expanding


@Routable("contractor/billing")
class ContractorBillingInfo() : ContractorPage, PaymentScreen, ContractorPaymentInfo() {

    override val title: Readable<String> = Constant("Billing")

    val contractor = shared { notNullSession().contractors[notNullContractor()]()!! }

    override fun ViewWriter.renderMainContent() {
        scrolls - col {
            spacing = 0.dp

            if (viewIsNarrow) notificationBar(AppColors.yellow) - body("Please view this information on a larger screen.")
            else sizeConstraints(width = AppDimensions.pageWidth) - padded - stack {
                spacing = AppDimensions.backgroundIndent

                space(AppDimensions.backgroundIndent)

                rowCollapsingToColumn(AppDimensions.pageWidth * 2) {
                    expanding - billingHistoryTable()
                    expanding - transferHistoryTable()
                }
            }
        }
    }
}